import { useTheme } from '../theme/useTheme';
import { LIGHT_THEME } from '../theme/themeClasses';

export function ThemeToggle({ tabIndex }: { tabIndex?: number }) {
  const { theme, isDark, toggle } = useTheme();

  return (
    <button
      type="button"
      id="theme-toggler"
      className={`nav-buttons${theme === LIGHT_THEME ? ' buttonSelected' : ''}`}
      title="Toggle Dark Mode"
      aria-label="Toggle Dark Mode"
      tabIndex={tabIndex}
      onClick={toggle}
    >
      <span>
        <i className={isDark ? 'fas fa-moon' : 'fas fa-sun'} role="img" aria-hidden="true">
          <span className="visually-hidden-focusable">Toggle Dark Mode</span>
        </i>
      </span>
    </button>
  );
}
